export default "__VITE_ASSET__pCl8m_eI__"